export default {
  name: 'marking--treeMrkReportUnusedByGtin',
  apiService: 'shoes',
  apiPath: '/admin/export_file/tree-mrk-report',
  urlParamName: 'marking--treeMrkReportUnusedByGtin',
};
